'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

RasterScheduleDirective=function(_BaseControllerBacked){_inherits(RasterScheduleDirective,_BaseControllerBacked);function RasterScheduleDirective(){_classCallCheck(this,RasterScheduleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(RasterScheduleDirective,[{key:'objectBindings',get:function()
{
return[
'displayTimeZone',
'timezoneDescription',
'estimatesAsOfTime',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'timeOfLastHosStatus',
'predictedWorkday',
'forecastDutyInterval',
'dutyFormatter',
'tripFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'personalStatistics'];
}},{key:'templateUrl',get:function()

{
return'/templates/features/personalSchedule/components/rasterSchedule/rasterScheduleView';
}},{key:'controller',get:function()

{
return RasterScheduleDirectiveController;
}}]);return RasterScheduleDirective}(BaseControllerBackedDirective);let


RasterScheduleDirectiveController=function(){
function RasterScheduleDirectiveController(timeFormattingService,$element,$window,$scope){var _this2=this;_classCallCheck(this,RasterScheduleDirectiveController);
this._timeFormattingService=timeFormattingService;

this.axisLabelFormatter=this.use24HourTimeline?Formatters.utcAxisTimeLabel_24Hour:
Formatters.utcAxisTimeLabel;

this.selectedInterval={};

const handleClick=function(event){
const focusedRect=angular.element($element).find('rect:focus');

if(!_.exists(focusedRect)||focusedRect.length===0){
_this2.selectedInterval={};
}
};

this._handleClick=handleClick.bind(this);

angular.element($window).on('click',this._handleClick);

$scope.$on('$destroy',function(){
angular.element($window).off('click',_this2._handleClick);
});
}_createClass(RasterScheduleDirectiveController,[{key:'timeFormattingService',get:function()

{
return this._timeFormattingService;
}},{key:'use24HourTimeline',get:function()

{
return this._timeFormattingService.safeUse24HourTimelineSetting;
}}]);return RasterScheduleDirectiveController}();


module.exports=RasterScheduleDirective;
//# sourceMappingURL=rasterScheduleDirective.js.map
